
import AOS from 'aos';

AOS.init({
  duration: 800,
  delay: 200,
  once: true,
});
